(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-request"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('trade-material-request')) {
  class TradeMaterialRequest extends HTMLElement {
    connectedCallback() {
      this.scheduleInit();
      this.observer?.disconnect();
      this.observer = new MutationObserver(records => {
        const containsConfig = node => node.nodeType === 1 &&
          (node.matches('[data-tmrf-config]') || node.querySelector('[data-tmrf-config]'));
        const changed = records.some(record =>
          record.target.matches?.('[data-tmrf-config]') ||
          record.target.parentElement?.matches('[data-tmrf-config]') ||
          [...record.addedNodes, ...record.removedNodes].some(containsConfig)
        );
        if (changed) this.scheduleInit();
      });
      this.observer.observe(this, { childList: true, subtree: true, characterData: true });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
    }

    scheduleInit() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.form = this.querySelector('form');
      this.format = this.querySelector('[data-tmrf-format]');
      this.fulfillment = this.querySelector('[data-tmrf-fulfillment]');
      this.quantity = this.querySelector('[data-tmrf-quantity]');
      this.date = this.querySelector('[data-tmrf-date]');
      this.address = this.querySelector('[data-tmrf-address]');
      this.submitButton = this.querySelector('[data-tmrf-submit]');
      this.error = this.querySelector('[data-tmrf-error]');
      if (!this.form || !this.submitButton || !this.quantity || !this.date || !this.format || !this.fulfillment || !this.address) {
        this.showSetup(['Form markup is incomplete. Replace the entire section file. Add it using Add section, not inside Buy buttons or another form.']);
        return;
      }
      this.submitButton.disabled = true;
      try {
        this.c = JSON.parse(this.querySelector('[data-tmrf-config]').textContent);
        if (!this.c || !this.c.settings || typeof this.c.settings !== 'object') throw new Error('settings');
        this.s = this.c.settings;
        this.c.source = String(this.c.source ?? this.s.price_source ?? '').trim();
        this.c.currency = String(this.c.currency || '').trim().toUpperCase();
        this.c.activeCurrency = String(this.c.activeCurrency || this.c.currency).trim().toUpperCase();
        this.formatter = new Intl.NumberFormat(this.c.locale || 'en', {
          style: 'currency', currency: this.c.currency, currencyDisplay: 'code',
          minimumFractionDigits: 2, maximumFractionDigits: 2
        });
      } catch {
        this.clearEstimate(this.s?.config_error);
        this.showSetup(['The calculator settings could not be read. Replace the entire section file, save, and reload the editor. Check that the store currency and locale are valid.']);
        if (this.error) {
          this.error.textContent = this.s?.config_error || this.querySelector('[data-tmrf-incomplete]')?.textContent || '';
          this.error.hidden = false;
        }
        return;
      }
      this.querySelector('[data-tmrf-fields]').disabled = false;
      this.configureDate();
      this.form.addEventListener('input', event => {
        if (event.target === this.quantity || event.target === this.date) this.update(false);
      }, { signal });
      this.form.addEventListener('change', event => {
        const switched = event.target === this.format || event.target === this.fulfillment;
        if (switched || event.target === this.quantity || event.target === this.date) this.update(switched);
      }, { signal });
      this.form.addEventListener('submit', event => {
        this.configureDate();
        const ready = this.update(false);
        const validFields = this.form.reportValidity();
        if (!ready || !validFields) {
          event.preventDefault();
          if (!ready && !this.error.hidden) this.error.focus();
          return;
        }
        this.writeBody();
      }, { signal });
      this.update(true);
      this.querySelector('[data-tmrf-success]')?.focus({ preventScroll: true });
    }

    message(key, replacements = {}) {
      let value = String(this.s?.[key] || '');
      for (const [token, replacement] of Object.entries(replacements)) {
        value = value.replaceAll(`{${token}}`, String(replacement));
      }
      return value;
    }

    minor(value) {
      if (value === null || value === undefined) return null;
      const match = /^(\d+)(?:\.(\d*))?$/.exec(String(value).trim());
      if (!match) return null;
      const fraction = (match[2] || '').replace(/0+$/, '');
      if (fraction.length > 2) return null;
      const amount = BigInt(match[1]) * 100n + BigInt(fraction.padEnd(2, '0'));
      return amount <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(amount) : null;
    }

    integer(value, fallback, minimum) {
      if (value === null || value === undefined || String(value).trim() === '') return fallback;
      const parsed = Number(value);
      return Number.isSafeInteger(parsed) && parsed >= minimum ? parsed : null;
    }

    flag(value) {
      return value === true || value === 'true';
    }

    money(value) {
      return this.formatter.format(value / 100);
    }

    configureDate() {
      this.dateConfigValid = false;
      this.dateIssue = '';
      this.date.removeAttribute('min');
      const lead = this.integer(this.s.lead_days, 0, 0);
      if (lead === null || lead > 3650) {
        this.dateIssue = 'Minimum calendar days ahead must be a whole number from 0 to 3650.';
        return;
      }
      const zone = String(this.s.time_zone || '').trim();
      if (!zone) {
        this.dateIssue = 'Business time zone is blank. Enter the fulfillment location time zone, for example Pacific/Honolulu for Hawaii.';
        return;
      }
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        const part = key => Number(parts.find(item => item.type === key).value);
        const date = new Date(Date.UTC(part('year'), part('month') - 1, part('day') + lead));
        this.date.min = date.toISOString().slice(0, 10);
        this.dateConfigValid = true;
        this.effectiveTimeZone = zone;
      } catch {
        this.dateIssue = `Business time zone "${zone}" is invalid or unsupported. Use a valid IANA zone such as Pacific/Honolulu for Hawaii.`;
      }
    }

    showSetup(issues) {
      this.setupIssues = [...issues];
      const box = this.querySelector('[data-tmrf-diagnostics]');
      if (!box) return;
      const context = box.querySelector('[data-tmrf-diagnostic-context]');
      if (context) {
        const mode = this.c?.source === 'manual' ? 'Theme editor prices' : this.c?.source === 'variants' ? 'Product variant prices' : 'Unknown price source';
        const product = this.c?.product || 'No product found';
        const price = this.format?.value === 'yard' ? this.s?.yard_price : this.s?.bag_price;
        context.textContent = `${issues.length ? 'Setup needs attention.' : 'Setup checks passed.'} Source: ${mode}. Product: ${product}.${this.c?.source === 'manual' ? ` Selected manual unit price: ${price ?? 'not set'} ${this.c.currency || ''}.` : ''}`;
      }
      const list = box.querySelector('[data-tmrf-diagnostic-list]');
      if (!list) return;
      list.replaceChildren();
      for (const issue of issues) {
        const li = document.createElement('li');
        li.textContent = issue;
        list.append(li);
      }
      list.hidden = issues.length === 0;
    }

    put(key, value) {
      const output = this.querySelector(`[data-tmrf-out="${key}"]`);
      if (output) output.value = value;
      const display = this.querySelector(`[data-tmrf-display="${key}"]`);
      if (display) display.textContent = value;
    }

    clearEstimate(message) {
      this.querySelector('[data-tmrf-summary]').hidden = true;
      const incomplete = this.querySelector('[data-tmrf-incomplete]');
      incomplete.hidden = false;
      incomplete.textContent = message || this.s?.empty_label || '';
      this.querySelectorAll('[data-tmrf-out]').forEach(field => { field.value = ''; });
      this.querySelector('[data-tmrf-body]').value = '';
      this.lastEstimate = null;
    }

    update(adjustMinimum) {
      const bag = this.format.value === 'bag';
      const yard = this.format.value === 'yard';
      const delivery = yard && this.fulfillment.value === 'delivery';
      const pickup = yard && this.fulfillment.value === 'pickup';
      const minimumSetting = bag ? 'bag_min' : delivery ? 'delivery_min' : 'pickup_min';
      const maximumSetting = bag ? 'bag_max' : 'yard_max';
      const min = this.integer(this.s[minimumSetting], delivery ? 2 : 1, 1);
      const max = this.integer(this.s[maximumSetting], 0, 0);
      const minimum = min ?? (delivery ? 2 : 1);
      this.quantity.min = String(minimum);
      this.quantity.step = '1';
      if (max) this.quantity.max = String(max);
      else this.quantity.removeAttribute('max');
      if (adjustMinimum && (!this.quantity.value || Number(this.quantity.value) < minimum)) this.quantity.value = String(minimum);
      this.querySelector('[data-tmrf-fulfillment-wrap]').hidden = !yard;
      this.fulfillment.disabled = !yard;
      this.querySelector('[data-tmrf-quantity-label]').textContent = bag ? this.s.bag_qty_label : this.s.yard_qty_label;
      this.querySelector('[data-tmrf-minimum]').textContent = this.message('min_label', { min: minimum });
      this.querySelector('[data-tmrf-note]').textContent = bag ? this.s.bag_note : delivery ? this.s.delivery_note : this.s.pickup_note;
      this.address.required = this.flag(this.s.address_required) || delivery;
      this.querySelector('[data-tmrf-address-star]').hidden = !this.address.required;
      this.querySelector('[data-tmrf-load-row]').hidden = !pickup;
      this.querySelector('[data-tmrf-truck-row]').hidden = !delivery;
      const quoted = delivery && this.s.delivery_mode === 'quote';
      this.querySelector('[data-tmrf-total-label]').textContent = bag ? this.s.bag_total_label : quoted ? this.s.partial_label : this.s.total_label;
      this.quantity.setCustomValidity('');
      const count = this.quantity.valueAsNumber;
      if (!Number.isSafeInteger(count) || count < minimum) {
        this.quantity.setCustomValidity(this.message('quantity_error', { min: minimum }));
      } else if (max && count > max) {
        this.quantity.setCustomValidity(this.message('maximum_error', { max }));
      }
      this.date.setCustomValidity('');
      if (this.dateConfigValid && this.date.value && this.date.value < this.date.min) {
        this.date.setCustomValidity(this.message('date_error', { date: this.date.min }));
      }
      const manual = this.c.source === 'manual';
      const variant = this.c.source === 'variants';
      const chosenVariant = bag ? this.c.bagVariant : this.c.yardVariant;
      const unit = manual ? this.minor(bag ? this.s.bag_price : this.s.yard_price)
        : this.integer(bag ? this.c.bagMinor : this.c.yardMinor, null, 0);
      const load = pickup ? this.minor(this.s.pickup_fee) : 0;
      const truck = delivery && !quoted ? this.minor(this.s.delivery_fee) : 0;
      const pricingIssues = [];
      if (!((bag && this.flag(this.s.show_bags)) || (yard && this.flag(this.s.show_yards) && (pickup || delivery)))) {
        pricingIssues.push('Enable the selected format under Heading and options, and choose a valid fulfillment method.');
      }
      if (!manual && !variant) pricingIssues.push('Choose a valid Price source in the Prices settings.');
      if (min === null) pricingIssues.push(`The ${bag ? 'Minimum bags' : delivery ? 'Delivery minimum cubic yards' : 'Pickup minimum cubic yards'} setting must be a whole number of at least 1.`);
      if (max === null || (max && max < minimum)) pricingIssues.push(`The ${bag ? 'Maximum bags' : 'Maximum cubic yards'} setting must be 0 for no limit, or a whole number at least ${minimum}.`);
      if (variant && !chosenVariant) pricingIssues.push(`No matching ${bag ? 'bag' : 'cubic yard'} variant was found. Check its exact title, or use Theme editor prices.`);
      if (!Number.isSafeInteger(unit) || unit <= 0) pricingIssues.push(manual
        ? `Manual price per ${bag ? 'bag' : 'cubic yard'} must be greater than 0 and use no more than two decimal places. Enter numbers without a currency symbol.`
        : 'The selected variant does not have a valid price greater than 0.');
      if (pickup && (!Number.isSafeInteger(load) || load < 0)) pricingIssues.push('Bulk pickup load fee must be a number of 0 or more. Enter 8 for an $8 loading fee in a USD store.');
      if (delivery && !['quote', 'fixed'].includes(this.s.delivery_mode)) pricingIssues.push('Choose Quote separately or Fixed fee per request under Trucking fee.');
      if (delivery && !quoted && (!Number.isSafeInteger(truck) || truck < 0)) pricingIssues.push('Fixed trucking fee must be a number of 0 or more. Use Quote separately when the charge is not yet known.');
      if (variant && this.flag(this.s.show_bags) && this.flag(this.s.show_yards) && this.c.bagVariant && this.c.bagVariant === this.c.yardVariant) {
        pricingIssues.push('Bag and cubic yard titles point to the same variant. Select distinct variants.');
      }
      const sameCurrency = this.c.currency === this.c.activeCurrency;
      if (!sameCurrency) pricingIssues.push(`This form uses ${this.c.currency}. Switch the storefront currency from ${this.c.activeCurrency} to ${this.c.currency}. No automatic currency conversion is performed.`);
      const submitIssues = [];
      if (!String(this.c.productId || '').trim()) submitIssues.push('No product was found. Open a real product in the product-template preview, or select Product override (optional) at the top of the section settings. On a regular page or the homepage, choose a product explicitly.');
      if (!this.dateConfigValid) submitIssues.push(this.dateIssue);
      let estimateValid = pricingIssues.length === 0 && this.quantity.validity.valid;
      if (estimateValid) {
        const subtotal = unit * count;
        const total = subtotal + load + truck;
        if (!Number.isSafeInteger(subtotal) || !Number.isSafeInteger(total)) {
          this.quantity.setCustomValidity(this.message('maximum_error', { max: Math.floor((Number.MAX_SAFE_INTEGER - load - truck) / unit) }));
          estimateValid = false;
        } else {
          this.put('format', bag ? this.s.bag_label : this.s.yard_label);
          this.put('variant', variant ? chosenVariant : '');
          this.put('sku', variant ? (bag ? this.c.bagSku : this.c.yardSku) : '');
          this.put('fulfillment', bag ? this.s.bag_note : delivery ? this.s.delivery_label : this.s.pickup_label);
          this.put('unit', this.money(unit));
          this.put('subtotal', this.money(subtotal));
          this.put('load', this.money(load));
          this.put('truck', quoted || bag ? this.s.quoted_label : this.money(truck));
          this.put('total', this.money(total));
          this.lastEstimate = { bag, delivery, pickup, quoted, count, unit, subtotal, load, truck, total };
          this.querySelector('[data-tmrf-summary]').hidden = false;
          this.querySelector('[data-tmrf-incomplete]').hidden = true;
        }
      }
      if (!estimateValid) this.clearEstimate(pricingIssues.length ? this.s.config_error : this.quantity.validationMessage);
      const issues = [...pricingIssues, ...submitIssues];
      this.showSetup(issues);
      this.error.hidden = issues.length === 0;
      this.error.textContent = !sameCurrency ? this.message('currency_error', { currency: this.c.currency })
        : pricingIssues.length ? this.s.config_error
        : submitIssues.length ? (this.s.submission_error || this.s.config_error) : '';
      const ready = estimateValid && submitIssues.length === 0;
      this.submitButton.disabled = !ready;
      return ready;
    }

    writeBody() {
      const e = this.lastEstimate;
      if (!e) return;
      const read = key => this.querySelector(`[data-tmrf-out="${key}"]`)?.value || '';
      const lines = [
        'PRODUCT REQUEST: NOT AN ORDER',
        `Product: ${this.c.product}`, `Product ID: ${this.c.productId}`, `Product URL: ${this.c.url}`, `Page URL: ${this.c.pageUrl}`,
        `Format: ${read('format')}`, `Variant ID: ${read('variant')}`, `SKU: ${read('sku')}`,
        `Quantity: ${e.count}`, `Fulfillment: ${read('fulfillment')}`,
        `Unit price: ${read('unit')}`, `Materials estimate: ${read('subtotal')}`,
        `Load fee: ${read('load')}`, `Trucking fee: ${read('truck')}`,
        `${e.quoted ? 'Estimate before trucking' : e.bag ? 'Estimated bag amount' : 'Estimated total'}: ${read('total')}`,
        `Currency: ${this.c.currency}`, `Needed date: ${this.date.value}`,
        `Business time zone: ${this.effectiveTimeZone}`, `Address: ${this.address.value.trim()}`,
        `Additional notes: ${this.querySelector('[data-tmrf-notes]').value.trim()}`,
        '', this.s.disclaimer,
        '', 'Merchant check: totals are calculated in the browser and can be edited by the sender. Verify prices, minimums, fees, availability, address, and requested date before confirming.'
      ];
      this.querySelector('[data-tmrf-body]').value = lines.join('\n');
    }
  }
  customElements.define('trade-material-request', TradeMaterialRequest);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches?.('trade-material-request')) event.target.scheduleInit();
    event.target.querySelectorAll?.('trade-material-request').forEach(element => element.scheduleInit());
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["state-launch-singup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trade-state-signup')) {
    class TradeStateSignup extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
      }
      initialize() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.form = this.querySelector('form');
        this.state = this.querySelector('[data-tsl-state]');
        this.firstName = this.querySelector('[data-tsl-name]');
        this.tags = this.querySelector('[data-tsl-tags]');
        this.fields = this.querySelector('[data-tsl-fields]');
        this.error = this.querySelector('[data-tsl-error]');
        if (!this.form || !this.state || !this.tags || !this.fields) return;
        const options = Array.from(this.state.options).filter(option => option.value && !option.disabled);
        const validSetup = options.length > 0 && this.dataset.groupTag && this.dataset.statePrefix && this.dataset.namePrefix;
        if (!validSetup) {
          this.fields.disabled = true;
          this.error.textContent = this.dataset.setupError;
          this.error.hidden = false;
          const editorNote = this.querySelector('[data-tsl-editor-note]');
          if (editorNote) editorNote.hidden = false;
          return;
        }
        this.fields.disabled = false;
        this.error.hidden = true;
        this.form.addEventListener('input', () => this.updateTags(), { signal });
        this.form.addEventListener('change', () => this.updateTags(), { signal });
        this.form.addEventListener('submit', event => {
          this.updateTags();
          if (!this.form.reportValidity()) event.preventDefault();
        }, { signal });
        this.state.addEventListener('invalid', () => {
          if (!this.state.value) this.state.setCustomValidity(this.dataset.stateError);
        }, { signal });
        this.updateTags();
        const message = this.querySelector('[data-tsl-success], [data-tsl-server-error]');
        if (message && window.location.hash === '#' + this.form.id) message.focus({ preventScroll: true });
      }
      normalizeName(value) {
        return String(value || '').normalize('NFC').trim()
          .replace(/[^\p{L}\p{M}\p{N}]+/gu, '-')
          .replace(/^-+|-+$/g, '').slice(0, 60);
      }
      updateTags() {
        this.state.setCustomValidity('');
        const selected = this.state.selectedOptions[0];
        const tags = [this.dataset.groupTag];
        if (selected && selected.value && !selected.disabled) {
          tags.push(this.dataset.statePrefix + '-' + selected.value);
        }
        const name = this.normalizeName(this.firstName?.value);
        if (name) tags.push(this.dataset.namePrefix + '-' + name);
        this.tags.value = Array.from(new Set(tags)).join(',');
      }
    }
    customElements.define('trade-state-signup', TradeStateSignup);
  }

  } catch(e) { console.error(e); }
})();
})();
